import * as React from 'react';
import { connect } from 'react-redux';
import Dropzone from 'dropzone';
import notify from '../../../../../shared/feedback/notifications';
import { ProgressBar } from 'react-bootstrap';
import Api from '../../../../../shared/Api';
import { Translate } from '../../../../../shared/LanguageService';
import * as Features from '../../../../../shared/Features';
import { previewTemplate } from '../../../../../components/common/Dropzone';
import { default as ImageZoom } from './ImageZoom';

class ImageProcessingDropzone extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        Dropzone.autoDiscover = false;

        this.state = {
            uploading: false,
            uploadProgress: 0
        };

        this.initiateDropzone = this.initiateDropzone.bind(this);
        this.canUploadImage = this.canUploadImage.bind(this);
    }

    imageDropzone: Dropzone;

    componentDidMount() {
        this.initiateDropzone();
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (this.imageDropzone) {
            this.imageDropzone.destroy();
        }

        this.initiateDropzone();
    }

    render() {
        const { apiUrl } = window.appConfig;

        return (
            <div className="imageprocessing-dropzone-container">
                <form
                    id={`imageprocess${this.props.id}`}
                    className={`${
                        this.canUploadImage() ? 'dropzone' : ' '
                    } image-processing-modal-image imageprocessing-dropzone`}
                >
                    <ImageZoom
                        imageId={this.props.id}
                        isImageFavorite={this.props.isImageFavorite}
                        isImageEdited={this.props.isImageEdited}
                        onClickFavorite={this.props.onClickFavorite}
                        lowResImageSrc={`${apiUrl}/file/${this.props.lowResImageSrc}`}
                        highResImageSrc={`${apiUrl}/file/${this.props.highResImageSrc}`}
                        canZoom={this.props.canImageZoom}
                        canFavourite={Features.hasFeature(
                            Features.FavoriteImages,
                            this.props.user
                        )}

                        loaded={this.props.loaded}
                        onLoad={this.props.onLoad}
                    />
                </form>
                {this.state.uploading && (
                    <div className="dropzone-loading">
                        <ProgressBar
                            className="dropzone-progress"
                            active={this.state.uploadDone}
                            now={this.state.uploadProgress}
                            label={`${this.state.uploadProgress}%`}
                            max={100}
                            bsStyle="success"
                        />
                    </div>
                )}
            </div>
        );
    }

    canUploadImage() {
        return (
            Features.hasFeature(Features.AddEditedImages, this.props.user) ||
            (this.props.photographerIsEditor &&
                Features.hasFeature(
                    Features.HandleEditedImagesWhenPhotographerIsEditor,
                    this.props.user
                ))
        );
    }

    initiateDropzone() {
        if (!this.canUploadImage()) {
            return;
        }

        const { apiUrl } = window.appConfig;
        const url = `${apiUrl}/views/orders/${this.props.orderId}/imageprocessing?imageId=${this.props.id}`;

        let component = this;
        this.imageDropzone = new Dropzone(`#imageprocess${this.props.id}`, {
            acceptedFiles: 'image/jpeg,image/png,image/gif,application/pdf',
            dictDefaultMessage: Translate('dropzone/title'),
            dictFallbackMessage: Translate('dropzone/fallback'),
            dictInvalidFileType: Translate('dropzone/invalid-filetype'),
            dictRemoveFile: Translate('dropzone/remove-image'),
            dictCancelUpload: Translate('dropzone/cancel-upload'),
            dictCancelUploadConfirmation: Translate('dropzone/cancel-upload-confirmation'),
            autoProcessQueue: false,
            maxFiles: 1,
            url,
            previewTemplate: previewTemplate,
            init: function () {
                let dropzone = this;
                this.on('addedfiles', (files: DropzoneFile[]) => {
                    if (files.length > 1) {
                        notify.failure(
                            Translate(
                                'image-processing/notification/you-can-only-upload-one-image-at-a-time'
                            )
                        );
                        dropzone.removeAllFiles();
                    } else if (!component.canUploadImage()) {
                        notify.failure(
                            Translate(
                                'image-processing/notification/you-do-not-have-permission-to-upload-images'
                            )
                        );
                        dropzone.removeFile(files[0]);
                    } else if (!this.options.acceptedFiles.includes(files[0].type)) {
                        notify.failure(Translate('dropzone/invalid-filetype'));
                        dropzone.removeFile(files[0]);
                    } else {
                        this.processFile(files[0]);
                    }
                });

                this.on('sending', (file: DropzoneFile, xhr: XMLHttpRequest, data: FormData) => {
                    new Api().applyHeadersToXhr(xhr);
                    component.setState({ uploading: true });
                });

                this.on(
                    'uploadprogress',
                    (file: DropzoneFile, progress: number, bytesSent: number) => {
                        component.setState({ uploadProgress: progress });
                    }
                );

                this.on('success', (file: DropzoneFile, response: any) => {
                    component.setState({ uploading: false });
                    component.props.getLatestChildImage(response.id);
                    this.removeAllFiles();
                });
            }
        });
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        user: state.user
    };
}

function mapDispatchToProps(dispatch: any) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageProcessingDropzone);
